import Money from "@common/components/Atoms/Money";
import { TileSize } from "@common/models";
import { SettingsService } from "@pro/_services";
import { DashboardTile } from "@pro/components/Organisms/DashboardTile";
import { Routing } from "common/_constants";
import React from "react";
import { Link } from "react-router-dom";

interface EarningsState {
    earnings: {
        status: string;
        response: {
            has_candidates: boolean;
            previous_month_earnings_in_usd: number;
            potential_earnings_in_usd: number;
            overall_earnings_in_usd: number;
            top_earnings_in_usd: number;
        };
    };
}

const DashboardEarningsFooter = props => (
    <div className="c-dashboard__tile-footer">
        <Link
            to={Routing.Client.Pro.Profile.Panes.PAYMENT_HISTORY_ROUTE}
            className="c-button c-button--green">
            view payment history
        </Link>
    </div>
);

export class Earnings extends React.Component<any, EarningsState> {
    private _abortControllers: { [key: string]: AbortController } = {};

    constructor(props) {
        super(props);

        this.state = {
            earnings: {
                status: "pending",
                response: {
                    has_candidates: false,
                    previous_month_earnings_in_usd: 0,
                    potential_earnings_in_usd: 0,
                    overall_earnings_in_usd: 0,
                    top_earnings_in_usd: 0,
                },
            },
        };
        this.fetchEarnings = this.fetchEarnings.bind(this);
    }

    componentDidMount() {
        this.fetchEarnings();
    }

    componentWillUnmount() {
        const abortControllers = this._abortControllers;
        if (Object.keys(abortControllers).length > 0) {
            Object.keys(abortControllers).map(key => abortControllers[key].abort());
        }
    }

    fetchEarnings() {
        // Check to see if there already was an abortController, and if so, call abort on it
        if (this._abortControllers.getEarnings) {
            this._abortControllers.getEarnings.abort();
        }
        this._abortControllers.getEarnings = new AbortController();
        const signal = this._abortControllers.getEarnings.signal;

        SettingsService.getEarnings(signal).then(resp => {
            this.setState({ earnings: { status: "success", response: resp } });
        });
    }

    render() {
        const { earnings } = this.state;
        return (
            <DashboardTile
                title="earnings"
                description={
                    earnings.status === "success" && earnings.response.has_candidates
                        ? "you clearly know the right people."
                        : "your earnings are waiting..."
                }
                loading={earnings.status === "pending"}
                size={TileSize.sm}
                showFade={false}
                footer={<DashboardEarningsFooter />}>
                {earnings.status === "success" &&
                    earnings.response.has_candidates && (
                        <div className="c-dashboard__earnings">
                            <div className="c-dashboard__earnings-summary">
                                <div className="c-dashboard__earnings-row">
                                    <span>last month earnings</span>
                                    <Money
                                        className="u-text-purple"
                                        amount={earnings.response.previous_month_earnings_in_usd}
                                    />
                                </div>
                                <div className="c-dashboard__earnings-row">
                                    <span>potential earnings</span>
                                    <Money
                                        className="u-text-purple"
                                        amount={earnings.response.potential_earnings_in_usd}
                                    />
                                </div>
                                <div className="c-dashboard__earnings-row">
                                    <span>overall earnings</span>
                                    <Money
                                        className="u-text-purple"
                                        amount={earnings.response.overall_earnings_in_usd}
                                    />
                                </div>
                            </div>
                            <p>
                                <strong>did you know?</strong>
                                <br />
                                top relode agent:{" "}
                                <Money amount={earnings.response.top_earnings_in_usd} />
                                <br />
                            </p>
                        </div>
                    )}

                {earnings.status === "success" &&
                    !earnings.response.has_candidates && (
                        <div className="c-dashboard__blank">
                            <p className="u-text-gray">
                                See how top agents have found success with Relode. Read their
                                stories here.
                            </p>
                            <div className="u-text-center">
                                <a
                                    href="https://www.relode.com/blog/category/success-stories"
                                    className="c-button"
                                    target="_blank"
                                    rel="noopener noreferrer">
                                    get inspired
                                </a>
                            </div>
                        </div>
                    )}
            </DashboardTile>
        );
    }
}
